export default __webpack_public_path__ + "static/media/logo_home.db923b8d.png";